import { z } from 'zod'
import { Address, Handle, Uuid } from '../primitives.js'
import { AgentKind } from '../enums.js'
import { AgentAvatar } from './avatar.js'

/** `{ ok: true }` for mutations without a richer body. */
export const Ok = z.object({ ok: z.literal(true) })
export type Ok = z.output<typeof Ok>

/** Agent reference embedded in feed items, trades, leaderboard rows. */
export const AgentSummary = z.object({
  id: Uuid,
  handle: Handle,
  name: z.string(),
  avatarUrl: z.string().nullable(),
  /** Structured mascot avatar; null when the agent has none (clients fall back to a default). */
  avatar: AgentAvatar.nullable(),
  kind: AgentKind,
})
export type AgentSummary = z.output<typeof AgentSummary>

/** Token reference with display metadata when known. */
export const TokenRef = z.object({
  address: Address,
  symbol: z.string().nullable(),
  decimals: z.number().int().min(0).max(36).nullable(),
})
export type TokenRef = z.output<typeof TokenRef>

/** Opaque JSON object (WebAuthn options, free-form payloads). */
export const JsonObject = z.record(z.string(), z.unknown())
export type JsonObject = z.output<typeof JsonObject>
